<template>
  <v-card>
    <PageTitle
      class="text-center h5"
      text="Aviso!"
    />
    <v-sheet>
      <div class="p-4 text-center">
        <h6 class="text-center">
          Ops! Tivemos um problema ao carregar sua recomendação de módulos para este ciclo.
        </h6>
        <p>Entre em contato com a coordenação da sua escola.</p>
        <v-btn
          rounded
          class="bg-nitro"
          @click="$router.push({ name: homeRouteName })"
        >
          Voltar à página inicial
        </v-btn>
      </div>
    </v-sheet>
  </v-card>
</template>
<script>

import { studyNowRouteName } from '@/student/constants/routes'
import PageTitle from '@/common/components/PageTitle'

export default {
  components: {
    PageTitle,
  },
  data() {
    return {
      studyNowRouteName,
    }
  },
}
</script>
